import React from "react";
import { Control, RegisterOptions } from "react-hook-form";

import { InputFieldProps, SelectComponent } from "shared/components";

import { ISelectOption } from "./types";

export interface SelectProps extends InputFieldProps {
  options: ISelectOption[];
  control?: Control;
  SelectValue?: React.ComponentType<any>;
  Option?: React.ComponentType<any>;
  prefixIcon?: React.ComponentType<any>;
  validation?: RegisterOptions;
  isSearchable?: boolean;
  isCreatable?: boolean;
  isMulti?: boolean;
  setFieldValue?: (field: string, value: string | null) => void;
  filterOption?:
    | ((option: { value: string }, rawInput: string) => boolean)
    | null;
  onDropdownClose?: () => void;
  tabIndex?: number;
}

export const Select: React.FC<SelectProps> = (props) => {
  return <SelectComponent {...props} />;
};
